export class SolicitudConsultaPadron{

    constructor(){
          this.PadronPersona ="";
          this.Apellido1 ="";
          this.Apellido2 ="";
        this.NombreORazonSocial ="";
        this.CodigoEntidad ="";
    }


      PadronPersona : string;
      Apellido1 : string;
      Apellido2 : string;
      NombreORazonSocial : string;
      CodigoEntidad:string;
}
export default SolicitudConsultaPadron;